"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _authenticatedUserButtons = _interopRequireDefault(require("./authenticated-user-buttons"));
var _findAStorePin = _interopRequireDefault(require("../../find-a-store-pin"));
var _unauthenticatedUserButtons = _interopRequireDefault(require("./unauthenticated-user-buttons"));
require("./auxiliary-nav.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var AuxiliaryButtons = function AuxiliaryButtons(_ref) {
  var accountButton = _ref.accountButton,
    accountNav = _ref.accountNav,
    findAStorePin = _ref.findAStorePin,
    isUserAuthenticated = _ref.isUserAuthenticated,
    joinNowButton = _ref.joinNowButton,
    layout = _ref.layout,
    signInButton = _ref.signInButton,
    signOutButton = _ref.signOutButton,
    useCrateLayout = _ref.useCrateLayout,
    useMaxWidthLayout = _ref.useMaxWidthLayout;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ml-auto flex flex-shrink-none sb-auxiliaryNav"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(layout === 'desktop' ? 'ml6 flex items-center' : '')
  }, findAStorePin && layout === 'desktop' && /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('self-stretch flex items-center mr6', {
      'sb-auxiliaryNavItem--active': findAStorePin.active
    })
  }, /*#__PURE__*/_react["default"].createElement(_findAStorePin["default"], _extends({
    className: "inline-block pr3 ".concat(findAStorePin.className || ''),
    text: findAStorePin.text
  }, findAStorePin.otherProps))), isUserAuthenticated && /*#__PURE__*/_react["default"].createElement(_authenticatedUserButtons["default"], {
    accountButton: accountButton,
    accountNav: accountNav,
    layout: layout,
    signOutButton: signOutButton,
    useCrateLayout: useCrateLayout,
    useMaxWidthLayout: useMaxWidthLayout
  }), !isUserAuthenticated && /*#__PURE__*/_react["default"].createElement(_unauthenticatedUserButtons["default"], {
    joinNowButton: joinNowButton,
    signInButton: signInButton
  }), findAStorePin && layout === 'mobile' && /*#__PURE__*/_react["default"].createElement(_findAStorePin["default"], _extends({
    className: "block mt3 pr2 ".concat(findAStorePin.className || ''),
    text: findAStorePin.text
  }, findAStorePin.otherProps))));
};
AuxiliaryButtons.propTypes = process.env.NODE_ENV !== "production" ? {
  accountButton: _propTypes["default"].object,
  accountNav: _propTypes["default"].object,
  findAStorePin: _propTypes["default"].object,
  isUserAuthenticated: _propTypes["default"].bool,
  joinNowButton: _propTypes["default"].object,
  layout: _propTypes["default"].string,
  signInButton: _propTypes["default"].object,
  signOutButton: _propTypes["default"].object,
  useCrateLayout: _propTypes["default"].bool
} : {};
var _default = exports["default"] = AuxiliaryButtons;